import React from 'react';
import { useAtom } from 'jotai/index';
import classNames from 'classnames';
import moment from 'moment';
import styles from '../css/index.module.scss';
import InputsBlock from './InputsBlock';
import MyInput from '../../../components/MyInput';
import EmptyHeight from '../../../components/EmptyHeight';
import DropdownInput from '../../../components/DropdownInput';
import CalendarIcon from '../../../assets/icons/calendar.svg';
import ClipboardIcon from '../../../assets/icons/clipboard.svg';
import AddIcon from '../../../assets/icons/addGray.svg';
import CloseIcon from '../../../assets/formIcons/close.svg';
import ClipboardCopiedIcon from '../../../assets/icons/clipboard_copied.svg';
import useSingleAddressInputs from '../../../hooks/UseSingleAddressInputs';
import IconButton from '../../../components/IconButton';
import { WEEK_DAYS_NAME } from '../../../constants/addresses';
import MyCheckbox from '../../../components/MyCheckbox';
import PartnersServices from '../../../services/PartnersServices';
import MyDateInput from '../../../components/MyDateInput';
import MyButton from '../../../components/MyButton';
import { selectedPartnerAddressAtom } from '../../../atoms/partnersAtoms';
import DateServices from "../../../services/DateServices";
import { DATE_FORMAT } from '../../../constants';

function SingleAddressInfo({ saveAddress }) {
  const {
    values, setters, errors, events,
  } = useSingleAddressInputs({ saveAddress });
  const [selectedAddress] = useAtom(selectedPartnerAddressAtom);

  return (
    <div className={styles.singlePartnerInfo}>
      <div>
        <InputsBlock title="Основные данные">
          <DropdownInput
              wrapperClassName={styles.input}
              value={values.active}
              onChange={setters.active}
              error={errors.active}
              data={[{ value: 'active', label: 'Активен' }, { value: 'nonActive', label: 'Заблокирован' }]}
              labelTextTop="Статус"
              placeholder="Выберите статус"
          />
          <MyInput
              wrapperClassName={styles.input}
              value={values.name}
              onChange={setters.name}
              error={errors.name}
              labelTextTop="Название адреса"
              withLeftIcon={false}
          />
          <MyInput
              wrapperClassName={styles.input}
              value={values.address}
              onChange={setters.address}
              error={errors.address}
              labelTextTop="Строка адреса"
              withLeftIcon={false}
          />
          <div className={styles.phoneInputGroup}>
            <span className={styles.phoneInputLabel}>Номер телефона</span>
            <div className={classNames(styles.phoneInputRow, { [styles.phoneInputRowError]: errors.phone })}>
              <span className={styles.phoneCountryCode}>+7</span>
              <div className={styles.phonePrefixInput}>
                <MyInput
                  value={values.phonePrefix}
                  onChange={setters.phonePrefix}
                  withLeftIcon={false}
                  withCloseIcon={false}
                  placeholder="префикс 3-5"
                  maxLength={5}
                  inputMode="numeric"
                />
              </div>
              <MyInput
                wrapperClassName={styles.phoneMainInput}
                value={values.phoneMain}
                onChange={setters.phoneMain}
                withLeftIcon={false}
                withCloseIcon={false}
                placeholder="основной номер"
                maxLength={values.phoneMainMaxLength}
                inputMode="numeric"
              />
            </div>
            {errors.phone && <p className={styles.phoneInputError}>{errors.phone}</p>}
          </div>
          {!!values.hostessLogin && (
              <div className={styles.hostessLogin}>
                <span>Логин хостеса</span>
                <div className={styles.hostessLoginRow}>
                  <p>{values.hostessLogin}</p>
                  <IconButton
                      svgPath={values.hostessLoginCopied ? ClipboardCopiedIcon : ClipboardIcon}
                      wrapperClassName={styles.hostessLoginButton}
                      onClick={events.onClipboardClick}
                  />
                </div>
              </div>
          )}
        </InputsBlock>
        <EmptyHeight height={30} />
        <InputsBlock title="Лицензия до">
          <MyDateInput
              value={values.licenseDay}
              onChange={setters.licenseDay}
              inputProps={{
                // wrapperClassName: styles.dateInputLong,
              }}
          />
        </InputsBlock>
        {values.maxAdditionalPhones > 0 && (
          <>
            <EmptyHeight height={30} />
            <InputsBlock title="Информирование">
          {values.additionalPhones.map((phoneVal, index) => (
            <div className={styles.additionalPhoneRow} key={`additional-phone-${index}`}>
              <MyInput
                wrapperClassName={styles.input}
                value={phoneVal}
                onChange={events.setAdditionalPhoneAt(index)}
                labelTextTop={`Телефон ${index + 1}`}
                withLeftIcon={false}
                mask="+7 999 999 99 99"
              />
              <IconButton
                onClick={events.onRemoveAdditionalPhoneClick(index)}
                svgPath={CloseIcon}
                wrapperClassName={styles.additionalPhoneRemove}
              />
            </div>
          ))}
          {values.additionalPhones.length < values.maxAdditionalPhones && (
            <div className={styles.addPhoneButtonRow}>
              <MyButton
                text="Добавить номер"
                secondary
                onClick={events.onAddAdditionalPhoneClick}
              />
            </div>
          )}
            </InputsBlock>
            <EmptyHeight height={30} />
          </>
        )}
      </div>

      <InputsBlock title="График работы" width={392}>
        {values.weekDays.sort((a, b) => (a.weekday > b.weekday ? 1 : -1)).map((item, index) => (
          <div className={styles.weekDay} key={item.weekday}>
            <p className={styles.weekDayName}>{WEEK_DAYS_NAME[item.weekday]}</p>
            <div className={styles.inputsRow}>
              <div className={styles.inputsRowLeft}>
                <div className={styles.weekDayInput}>
                  <MyInput
                    value={item.open_time}
                    onChange={setters.weekDays(index, 'open_time')}
                    className={classNames({ [styles.weekDayInputDisabled]: item.day_off })}
                    wrapperClassName={styles.weekDayInputWrapper}
                    withLeftIcon={false}
                    withCloseIcon={false}
                    disabled={item.day_off}
                    mask="99:99"
                    placeholder="11:30"
                  />
                </div>
                <div className={styles.weekDayInput}>
                  <MyInput
                    value={item.close_time}
                    onChange={setters.weekDays(index, 'close_time')}
                    className={classNames({ [styles.weekDayInputDisabled]: item.day_off })}
                    wrapperClassName={styles.weekDayInputWrapper}
                    withLeftIcon={false}
                    withCloseIcon={false}
                    disabled={item.day_off}
                    mask="99:99"
                    placeholder="23:00"
                  />
                </div>
              </div>

              <MyCheckbox
                value={item.day_off}
                text="Выходной"
                onClick={setters.weekDays(index, 'day_off')}
              />
            </div>
          </div>
        ))}

        <p className={styles.weekDayError}>{errors.weekDays}</p>
      </InputsBlock>

      <div>
        <InputsBlock title="Выходные дни" width={660}>
          <div className={styles.holiday}>
            <div className={styles.inputsRow}>
              <div className={styles.inputsRowLeft}>
                <div className={styles.holidayDateInput}>
                  {/* <MyInput
                  value={values.holidayInputs.date}
                  onChange={setters.holidayInputs('date')}
                  withLeftIcon={false}
                  withCloseIcon={false}
                  mask="99.99.9999"
                  placeholder="01.01.2000"
                  floatingComponent={<img className={styles.dateInputIcon} src={CalendarIcon} alt="" />}
                /> */}
                  <MyDateInput
                      value={values.holidayInputs.date}
                      onChange={(value) => setters.holidayInputs('date')({ target: { value } })}
                      inputProps={{
                        wrapperClassName: styles.dateInput,
                      }}
                  />
                </div>
                <div className={styles.weekDayInput}>
                  <MyInput
                      value={values.holidayInputs.open_time}
                      onChange={setters.holidayInputs('open_time')}
                      className={classNames({ [styles.weekDayInputDisabled]: values.holidayInputs.day_off })}
                      wrapperClassName={styles.weekDayInputWrapper}
                      withLeftIcon={false}
                      withCloseIcon={false}
                      disabled={values.holidayInputs.day_off}
                      mask="99:99"
                      placeholder="11:30"
                  />
                </div>
                <div className={styles.weekDayInput}>
                  <MyInput
                      value={values.holidayInputs.close_time}
                      onChange={setters.holidayInputs('close_time')}
                      className={classNames({ [styles.weekDayInputDisabled]: values.holidayInputs.day_off })}
                      wrapperClassName={styles.weekDayInputWrapper}
                      withLeftIcon={false}
                      withCloseIcon={false}
                      disabled={values.holidayInputs.day_off}
                      mask="99:99"
                      placeholder="23:00"
                  />
                </div>
                <p className={styles.inputError}>{errors.holidayInputs}</p>
              </div>

              <MyCheckbox
                  value={values.holidayInputs.day_off}
                  text="Выходной"
                  onClick={setters.holidayInputs('day_off')}
              />

              <IconButton onClick={events.onAddHolidayClick} svgPath={AddIcon} />
            </div>

            {values.holidays.map((item, index) => (
                <div className={styles.holidayItem} key={item.date}>
                  <p className={styles.holidayItemDate}>{PartnersServices.convertDateFormat(item.date, 'DD.MM.YYYY', 'D MMMM YYYY')}</p>
                  <p className={styles.holidayItemTime}>
                    {item.day_off ? 'Выходной' : `${item.open_time}-${item.close_time}`}
                  </p>
                  <IconButton
                      onClick={events.onDeleteHolidayClick(index)}
                      svgPath={CloseIcon}
                      wrapperClassName={styles.holidayItemButton}
                  />
                </div>
            ))}
          </div>
        </InputsBlock>
        <EmptyHeight height={30} />
        {selectedAddress?.devices?.length > 0 && (
            <InputsBlock title="Список устройств" width={660}>
              <div className={styles.devicesList}>
                {selectedAddress.devices.map((i, index) => (
                    <div key={index} className={styles.devicesListItem}>
                      <div style={{display: 'flex'}}>
                        <p style={{width: '170px'}}>{i.device_name}</p>
                        <p style={{width: '170px'}} className={styles.devicesListItemPlatform}>{i.device_type}</p>
                        <p>{moment(i.updated_at).format('D MMMM YYYY HH:mm:ss')}</p>
                      </div>
                      <p className={styles.devicesListItemVersion}>{i.version}</p>
                    </div>
                ))}
              </div>
            </InputsBlock>
        )}
      </div>
    </div>
  );
}

export default SingleAddressInfo;
